export enum Currency {
  USD = "USD",
  JPY = "JPY",
}
